import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { DEFAULT_SIZE, DEFAULT_KIND, DEFAULT_TITLE_THEME } from '../../configs/config';
import type { TDefaultDesktop, IDesktopImgStyle } from '../../models';

export const Component: FC<React.PropsWithChildren<TDefaultDesktop>> = props => {
    const {
        Block,
        Grid,
        TextV2,
        Layout,
        bgPosition = 'center',
        bgRepeat = 'no-repeat',
        bgSize = 'auto',
        children,
        className,
        contentPlacement = 'left',
        contentWidth = DEFAULT_SIZE,
        dataTestId,
        gridJustify = 'start',
        id,
        imgUrl,
        minHeight,
        noPaddingBottom = false,
        renderButton,
        styles,
        styler,
        theme = DEFAULT_KIND,
        title,
        titleTheme = DEFAULT_TITLE_THEME,
    } = props;
    const style = {} as IDesktopImgStyle;

    if (imgUrl) {
        style.backgroundPosition = bgPosition;
        style.backgroundRepeat = bgRepeat;
        style.backgroundSize = bgSize;
        style.backgroundImage = `url(${imgUrl})`;

        if (minHeight) {
            style.minHeight = minHeight;
        }
    }

    /*
     * ToDo: Fed Artemyev скоро будет приводиться к единому стилю benefits-block
     * default и кастом нужно будет объединить в один
     */
    const columnsWidth = contentPlacement === 'right' ? [null, contentWidth] : [contentWidth, null];

    const column = (
        <div
            style={{
                height: '100%',
            }}
        >
            &nbsp;
        </div>
    );

    return (
        <Block
            className={cn(styles.block, styles.external)}
            dataTestId={dataTestId}
            id={id}
            notPadded
            styler={styler}
        >
            <Layout>
                <Block
                    className={cn(
                        styles.external,
                        {
                            [styles.noPaddingBottom]: noPaddingBottom,
                        },
                        className
                    )}
                    paddedType="perimeter48"
                    style={style}
                    theme={theme}
                >
                    <Grid columnsWidth={columnsWidth} justify={gridJustify}>
                        {contentPlacement === 'right' && column}
                        <>
                            {title && (
                                <TextV2
                                    styler={{
                                        marginTop: 0,
                                    }}
                                    tag={'h2'}
                                    theme={titleTheme}
                                    view="medium"
                                >
                                    {title}
                                </TextV2>
                            )}
                            {children}
                            {renderButton(props)}
                        </>
                        {contentPlacement !== 'right' && column}
                    </Grid>
                </Block>
            </Layout>
        </Block>
    );
};
